import * as React from 'react';
import { Pivot, PivotItem } from '@fluentui/react/lib/Pivot';
import * as types from '../../types';
import * as services from '../../services';
import { IGenColumn, ColumnType, ColumnDisplayType } from '../../types/GenColumn';
import PeriodList from '../period/PeriodList';
import EntityListCat from '../entity/EntityListCat';
import withMobileDetector from '../withMobileDetector';
import { isMobile } from 'react-device-detect';
import { IOrgConfig } from '../../types';
import { EntityList } from '../EntityList';
import { DefineSpecificAreaForm } from './DefineSpecificAreaForm';

export interface IGoPropertiesClsProps extends types.IBaseComponentProps {
    isMobile: boolean;
    orbConfig: IOrgConfig;
}

export interface IGoPropertiesState {
}

export class GoPropertiesState implements IGoPropertiesState {
}


class GoPropertiesCls extends React.Component<IGoPropertiesClsProps, GoPropertiesState> {
    private goDefElementService = new services.GoDefElementService();
    constructor(props: IGoPropertiesClsProps) {
        super(props);
        this.state = new GoPropertiesState();
    }

    public render(): React.ReactElement<IGoPropertiesClsProps> {
        return (
            <Pivot>
                <PivotItem headerText="Periods">
                    {this.renderCustomPeriodsList()}
                </PivotItem>
                <PivotItem headerText="Define Form">
                    {this.renderGoDefForms()}
                </PivotItem>
                <PivotItem headerText="Define Specific Areas">
                    {this.renderGoDefElements()}
                </PivotItem>
            </Pivot>
        );
    }

    private renderCustomPeriodsList() {
        const { isMobile } = this.props;
        const listColumns: IGenColumn[] = [
            {
                key: '1',
                columnType: ColumnType.TextBox,
                name: 'Name',
                fieldName: 'Title',
                minWidth: isMobile ? 55 : 80,
                maxWidth: isMobile ? 80 : 250,
                isResizable: true,
                isRequired: true,
                isMultiline: true,
                fieldMaxLength: 50,

            },
            {
                key: '2',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.ListOnly,
                name: isMobile ? 'Status' : 'Period Status',
                fieldName: 'PeriodStatus',
                minWidth: isMobile ? 55 : 75,
                maxWidth: isMobile ? 100 : 200,
                isResizable: true,
                isMultiline: true,
                fieldMaxLength: 50,
            },
            {
                key: '3',
                columnType: ColumnType.DatePicker,
                name: 'Start Date',
                fieldName: 'PeriodStartDate',
                minWidth: isMobile ? 65 : 85,
                maxWidth: isMobile ? 100 : 200,
                isResizable: true,
                isRequired: true,
                isCollapsible: true,
                fieldMaxLength: 50,
            },
            {
                key: '4',
                columnType: ColumnType.DatePicker,
                name: 'End Date',
                fieldName: 'PeriodEndDate',
                minWidth: isMobile ? 60 : 80,
                isResizable: true,
                isRequired: true,
                isCollapsible: true,
                fieldMaxLength: 50,
            },
        ];

        return (
            <React.Fragment>
                <PeriodList
                    allowAdd={this.allowAdd_Periods()}
                    columns={listColumns}
                    {...this.props}
                    errorHandling={this.props.errorHandling}
                    entityService={new services.GoPeriodService()}
                    entityNamePlural="Gov Periods"
                    entityNameSingular="Period"
                    childEntityNameApi=""
                    childEntityNamePlural=""
                    childEntityNameSingular=""
                />
            </React.Fragment>
        );
    }

    private renderGoDefForms() {
        const listColumns: IGenColumn[] = [
            {
                key: 'Title',
                columnType: ColumnType.TextBox,
                name: 'Welcome Text Heading',
                fieldName: 'Title',
                minWidth: 300,
                isResizable: true,
                isRequired: true,
                fieldMaxLength: 100
            },
            {
                key: 'Details',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Welcome Text',
                fieldName: 'Details',
                minWidth: 300,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 5000,
                numRows: 10
            },
            {
                key: 'Section1Title',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 1 Title',
                fieldName: 'Section1Title',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'Section1TitleMobile',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 1 Title for Mobile',
                fieldName: 'Section1TitleMobile',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'Section2Title',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 2 Title',
                fieldName: 'Section2Title',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'Section2TitleMobile',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 2 Title for Mobile',
                fieldName: 'Section2TitleMobile',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'Section3Title',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 3 Title',
                fieldName: 'Section3Title',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'Section3TitleMobile',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Section 3 Title for Mobile',
                fieldName: 'Section3TitleMobile',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 300
            },
            {
                key: 'SummaryShortInstructions',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Summary Short Instructions',
                fieldName: 'SummaryShortInstructions',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 1000,
                numRows: 3
            },
            {
                key: 'SummaryFullInstructions',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Summary Full Instructions',
                fieldName: 'SummaryFullInstructions',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 5000,
                numRows: 6
            },
            {
                key: 'SummaryFormRatingText',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: 'Summary Form Rating Text',
                fieldName: 'SummaryFormRatingText',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 2000,
                numRows: 3
            },
            {
                key: 'DGSignOffText',
                columnType: ColumnType.TextBox,
                columnDisplayType: ColumnDisplayType.FormOnly,
                name: `${this.props.orbConfig.OrgMgrL1Lable} SignOff Text`,
                fieldName: 'DGSignOffText',
                minWidth: 100,
                isResizable: true,
                isRequired: false,
                fieldMaxLength: 2000,
                numRows: 3
            },
        ];

        return (
            <React.Fragment>
                <EntityListCat
                    allowAdd={this.superUserPermission()}
                    columns={listColumns}
                    {...this.props}
                    errorHandling={this.props.errorHandling}
                    entityService={new services.GoDefFormService()}
                    entityNamePlural="Define Form"
                    entityNameSingular="Define Form"
                    childEntityNameApi=""
                    childEntityNamePlural=""
                    childEntityNameSingular=""
                />
            </React.Fragment>
        );
    }

    private renderGoDefElements() {

        return (
            <React.Fragment>
                <EntityList
                    entityName={{ Plural: 'Define Specific Areas', Singular: 'Define Specific Area' }}
                    columns={[
                        { key: '1', name: 'Name', fieldName: 'Title', minWidth: 100, isMultiline: true, maxWidth: 350, isResizable: true },
                        { key: '2', name: this.props.orbConfig.OrgL1Label, fieldName: 'OrgLevel1s', minWidth: 150, isResizable: true, isCollapsible: true, isMultiline: true },
                    ]}
                    loadListItems={() => this.goDefElementService.readAllForDefnList()}
                    mapEntitiesToListItems={x => x.map(x => (
                        {
                            key: x.ID,
                            Title: x.Title,
                            OrgLevel1s: [
                                x.GoDefElementOrgLevel1s && x.GoDefElementOrgLevel1s.some(y => y.OrgLevel1 != null) ? `${x.GoDefElementOrgLevel1s.map(y => y.OrgLevel1?.Title).join(', ')}` : `All ${this.props.orbConfig.OrgL1LabelP}`,
                            ].filter(Boolean).join(', '),
                        }
                    ))}
                    entityForm={(showForm, entityId, onSaved, onCancelled) =>
                        <DefineSpecificAreaForm
                            showForm={showForm}
                            entityId={entityId}
                            onSaved={onSaved}
                            onCancelled={onCancelled}
                            errorHandling={this.props.errorHandling}
                        />
                    }
                    onCheckDelete={() => Promise.resolve([])}
                    onDelete={id => this.goDefElementService.delete(id)}
                    entity={''}
                    errorHandling={this.props.errorHandling}
                    apiConnected={true}
                />

            </React.Fragment>
        );
    }

    private superUserPermission = (): boolean => {
        return this.props.userPermissions.UserIsSystemAdmin()
            || this.props.userPermissions.UserIsGovernanceSuperUser();
    }

    private allowAdd_Periods(): boolean {
        return this.superUserPermission();
    }
}

export default withMobileDetector(GoPropertiesCls);